"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/components/Checkbox.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

const noop = () => null
const stop = (e) => e.stopPropagation()












/* The input stays in the tab order (visually hidden) so Space works; its
 * click stays here, so a row that toggles on click doesn't toggle twice. */
const CampaignCheckbox = ({
  isChecked = false,
  isMixed = false,
  isDisabled = false,
  onChange = noop,
  label,
  className,
}) => {
  const inputRef = _react.useRef(null)
  _react.useEffect.call(void 0, () => { if (inputRef.current) inputRef.current.indeterminate = isMixed }, [isMixed])
  return (
    // oxlint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- only stops the input's click from reaching the row
    _react2.default.createElement('label', {
      className: _classBuilder2.default.call(void 0, 
        'campaign--table--checkbox',
        isMixed && 'campaign--table--checkbox--mixed',
        isDisabled && 'campaign--table--checkbox--disabled',
        className,
      ),
      onClick: stop, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}

      , _react2.default.createElement('input', {
        ref: inputRef,
        type: "checkbox",
        className: "broadcast-visually-hidden",
        'aria-label': label,
        checked: isChecked,
        disabled: isDisabled,
        onChange: () => onChange(!isChecked), __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
      )
      , _react2.default.createElement('div', { className: "campaign--table--checkbox-check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )
    )
  )
}

exports. default = CampaignCheckbox
